import { cn } from '../lib/utils'

interface StatCardProps {
  title: string
  value: number
  icon: React.ReactNode
  alert?: number
  color?: string
  onClick?: () => void
}

export function StatCard({ title, value, icon, alert, color = 'bg-saffron', onClick }: StatCardProps) {
  return (
    <div
      onClick={onClick}
      className={cn(
        'bg-white rounded-lg shadow-sm p-6 border border-gray-200',
        onClick && 'cursor-pointer hover:shadow-md transition-shadow',
      )}
    >
      <div className="relative">
        <div className="flex items-center justify-between mb-4">
          <div className={cn(color, 'p-3 rounded-lg text-white')}>
            {icon}
          </div>
          {alert && alert > 0 && (
            <div className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm font-semibold">
              {alert}
            </div>
          )}
        </div>
        <p className="text-gray-600 text-sm font-medium mb-1">{title}</p>
        <p className="text-3xl font-bold text-gray-900">{value.toLocaleString()}</p>
      </div>
    </div>
  )
}
